import React from 'react';
import { useTranslation } from 'react-i18next';
import ListPageHeader from '@shared/ListPageHeader';
import ThirdPartyApiLogList from '@shared/third_party_api_logs/ThirdPartyApiLogList';
import { thirdPartyApiLogService } from '@services/admin/thirdPartyApiLogService';
import { ecAccountService } from '@services/admin/ecAccountService';
import { shippingAccountService } from '@services/admin/shippingAccountService';

export default function AdminThirdPartyApiLogsList() {
  const { t } = useTranslation();

  return (
    <div>
      <ListPageHeader basePath="/admin" items={['platform', 'platform.api_logs']} />
      <ThirdPartyApiLogList
        role="admin"
        service={thirdPartyApiLogService}
        ecAccountService={ecAccountService}
        shippingAccountService={shippingAccountService}
      />
    </div>
  );
}
